import { useQuery } from '@tanstack/react-query';
import { API } from 'utils/globalApiServices';
import { useRealplayStore } from 'features/realplays/RealPlays.store';

const queryFn = async () => {
  const url = `/ai/personas/`;
  const { data } = await API.getTemporary(url);
  return data || [];
};

const useGetPersonasListQuery = ({ active }) => {
  const { setPersonasAI } = useRealplayStore();
  return useQuery({
    queryFn: () => queryFn(),
    queryKey: ['PERSONA_AI_INFO'],
    enabled: active,
    onSuccess: (response) => {
      const list = response?.personas.map((x) => ({
        ...x,
        isSelected: x?.name === 'Linda' ? true : false,
      }));
      setPersonasAI(list);
    },
  });
};

export default useGetPersonasListQuery;
